<template>
  <CustomPage title="账户明细" style="background: #f7f7f7">
    <div slot="content" style="height: 100%">
      <div class="account-detail-container">
        <div class="tabs">
          <div
            class="tab"
            :class="{ active: active === item.value }"
            v-for="item in tabs"
            :key="item.value"
            @click="tabClick(item.value)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div class="list">
          <div class="list-wrapper">
            <VirtualList
              :list="list"
              :dataComponent="dataComponent"
              @getData="onLoad"
              :finished="finished"
            />
          </div>
        </div>
      </div>
    </div>
  </CustomPage>
</template>

<script>
import { nanoid } from 'nanoid'
import { getClientFundsDetail } from '@/api/wallet'
import CustomPage from '@/components/custom-page.vue'
import dataComponent from './components/Item'
import VirtualList from '@/components/VirtualList'
export default {
  components: { CustomPage, VirtualList, },
  data() {
    return {
      dataComponent,
      active: 0,
      tabs: [
        { name: '全部', value: 0 },
        { name: '收入', value: 1 },
        { name: '支出', value: 2 },
      ],
      loading: false,
      finished: false,
      list: [],
      pagination: {
        total: 0,
        page: 1,
        size: 20,
      },
    }
  },
  methods: {
    tabClick(val) {
      this.active = val
      this.finished = false
      this.list = []
      this.pagination.page = 1
      this.onLoad()
    },
    onLoad() {
      const params = {
        customerId: this.$store.state.user.customerId,
        page: this.pagination.page - 1,
        size: this.pagination.size,
      }
      if (this.active === 1) {
        params.receiptType = true
      }
      if (this.active === 2) {
        params.receiptType = false
      }
      this.loading = true
      getClientFundsDetail(params)
        .then((res) => {
          const list = res.data.content.map(item => {
            return { ...item, id: nanoid() }
          })
          this.list.push(...list)
          this.pagination.total = res.data.totalElements
          if (res.data.content.length < this.pagination.size) {
            this.finished = true
          } else {
            this.pagination.page++
          }
        })
        .catch(() => {
          Toast.fail('获取数据失败')
          this.loading = false
          this.finished = true
        })
    },
  },
}
</script>

<style lang="less" scoped>
.account-detail-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .tabs {
    display: flex;
    padding: 22px 0 20px;
    background: #fff;
    .tab {
      flex: 1;
      text-align: center;
      span {
        display: inline-block;
        padding: 8px 32px;
        font-size: 24px;
        color: #666;
        line-height: 24px;
      }
      &.active span {
        color: #fff;
        background: #e82035;
        border-radius: 40px;
      }
    }
  }
  .list {
    margin-top: 24px;
    flex: 1;
    min-height: 0;
    background: #fff;
    overflow: hidden;
    .list-wrapper {
      height: 100%;
      overflow: hidden;
    }
  }
}
</style>